import { makeSubscriber } from "../helpers/make_subscriber";
import type {
  ConversationId,
  ProPilotFrame,
  ProPilotMessagePayload,
  ProPilotSocket,
  ProPilotSocketFactory
} from "../types";

// fallow-ignore unused-type
export interface MockProPilotSocket extends ProPilotSocket {
  _emitError: (reason: string) => void;
}

export const createMockProPilotSocket: ProPilotSocketFactory = () => {
  const subscribers = new Set<(frame: ProPilotFrame) => void>();
  const errorSubscribers = new Set<(reason: string) => void>();
  let conversationId: ConversationId | null = null;
  let isClosed = false;

  const socket: MockProPilotSocket = {
    connect: (id: ConversationId) => {
      if (isClosed) {
        return Promise.reject(new Error("[mockProPilotSocket] socket is closed"));
      }
      conversationId = id;
      return Promise.resolve();
    },

    send: (payload: ProPilotMessagePayload): boolean => {
      if (isClosed) {
        return false;
      }
      const responseFrame: ProPilotFrame = { type: "response", text: `Mock echo: ${payload.message}` };
      const doneFrame: ProPilotFrame = { type: "done" };
      setTimeout(() => {
        // fan out to a snapshot so unsubscribes during dispatch don't skip subs
        [...subscribers].forEach((cb) => cb(responseFrame));
        [...subscribers].forEach((cb) => cb(doneFrame));
      }, 0);
      return true;
    },

    onResponse: makeSubscriber(subscribers),

    onError: makeSubscriber(errorSubscribers),

    reconnect: () => {
      if (isClosed) {
        return Promise.reject(new Error("[mockProPilotSocket] socket is closed"));
      }
      return Promise.resolve();
    },

    close: () => {
      subscribers.clear();
      errorSubscribers.clear();
      conversationId = null;
      isClosed = true;
    },

    _emitError: (reason: string) => {
      [...errorSubscribers].forEach((cb) => cb(reason));
    }
  };

  void conversationId;

  return socket;
};
